import http from "../../http-common";

export default class {
  getUserInfo() {
    let url = "/sso/user";

    return http.get(url);
  }
}
